module.exports = "fragment Redirect on RedirectType{__typename id oldPath newPath}"